/* eslint-disable @tanstack/query/exhaustive-deps -- queryFn closes over Clerk getToken; cache keyed by userId+sessionId */
import { useAuth } from '@clerk/react';
import { useQuery } from '@tanstack/react-query';
import { fetchRecentPayments } from '../api/accountApi';
import { useAccountGetToken } from './useAccountApi';

export function useRecentStripePayments(enabled = true) {
  const { userId, sessionId } = useAuth();
  const getToken = useAccountGetToken();
  return useQuery({
    queryKey: ['account', 'billingRecentPayments', userId, sessionId],
    queryFn: () => fetchRecentPayments(getToken),
    enabled: Boolean(userId) && enabled,
    select: data => data.payments
  });
}
